// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"NoteHistoryDialog_modalTitle_TauWL","spinAround":"NoteHistoryDialog_spinAround_RkPgS"};